export default function CardDisclaimerBase({ disclaimer }) {
  return (
    <>
      <hr className="ui-mobile-collapse" />
      <article className="text-left text-xs text-theme-text-secondary px-4 md:px-6 py-4">
        {disclaimer}
      </article>
    </>
  );
}
